import { FC } from "react"
import { AttentionsSuccess } from "../../../module/attentions/containers/success"

export const AttentionsSuccessPage: FC = () => <AttentionsSuccess />
